<template>
  <div id="editor" v-html="value"></div>
</template>
<script>
import { abstractField } from 'vue-form-generator'

export default {
  data () {
    return {
      editorData: null
    }
  },
  mixins: [abstractField],
  mounted () {
    this.init()
    // CKEDITOR.instances.editor.setData(this.value)
  },
  methods: {
    init () {
      // CKEDITOR.config.height = 400
      // CKEDITOR.config.width = '100%'
      // CKEDITOR.replace('editor')
    }
  }
}
</script>
<style lang="stylus">
textarea
  width 100%
  border 1px solid #ccc
  border-radius 4px
  padding 10px

.ck.ck-editor
  width 100%

  .ck-editor__editable
    min-height 500px

  .ck-editor__editable
    table
      width 100%
      table-layout fixed

      td
        vertical-align top

</style>
